import { render, staticRenderFns } from "./grid-manager.vue?vue&type=template&id=1a72ccb9&"
import script from "./grid-manager.vue?vue&type=script&lang=js&"
export * from "./grid-manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports